module.exports = "<!-- LFWM-4311 -->\n<!-- Starting of popup page (ship refer Show MBOL error log) -->\n<div class=\"ship-popup-wrapper\">\n  <lfwms-result-data-table [searchService]=\"lookupSearchService\"\n    [popupMode]=\"true\">\n  </lfwms-result-data-table>\n</div>\n<!-- Ending of popup page (ship refer Show MBOL error log) -->"


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/lookup/ship-ref-popup/show_mbol_error_popup/show-mbol-error-log-popup.component.html
// module id = ../../../../../src/app/shared/lookup/ship-ref-popup/show_mbol_error_popup/show-mbol-error-log-popup.component.html
// module chunks = main